const config = {
    API_URL_BASE: "https://portal.vs.unimed.com.br:9001/u_apiAutOnline.apw",
    URL_BASE:"https://portal.vs.unimed.com.br:9001/",
    URL_EMAIL_BASE:"https://portaldocliente.vs.unimed.com.br/portaldocliente/arqs/ajSolDoc.php",
    URL_BASE_PORTAL: "https://portaldocliente.unimedvs.com.br/",
    API_URL_MOSIA: "https://api.mosiaomnichannel.com.br/clientes/ocorrencias",
    AUT_MOSIA: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlzIjoib2NvcnJlbmNpYXMiLCJrZXkiOiIwMzBmMjhjZi00M2ZhLTRmNGItYTc2NS02ZWUwOWE0MjY5MGIiLCJpYXQiOjE3Mjc3ODEwNDEsImV4cCI6MzMwNTY2MTA0MSwiYXVkIjoiYWxsIn0.Sc1w9gL5OZXOkIpialTeZbpkMQ7YaKcM1CegOi6jY0k",
    API_URL_MATVID: "https://api-unimedvs.sensedia.com/clientedigital/matriculaVida",
    API_TOKEN_SENSEDIA: "Basic MTQ2YzMxYzgtY2NjMC0zYTM4LTk4MWYtMzY0MmI3YjVkZWI0OmViNzgwMTQyLTM5MDAtM2Y3My05ZmE5LTNhMjM3Y2Q0ZWM1ZQ==",
    //API_REST_PROTHEUS: "https://intprot.unimedvs.com.br:7019/rest",
    API_REST_PROTHEUS: "https://intprot01.unimedvs.com.br:9064/rest",
    API_CLIENTE_DIGITAL: "https://api-unimedvs.sensedia.com/clientedigital"
};

export default config;

// export default{
//     // HML AUT_MOSIA: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlzIjoib2NvcnJlbmNpYXMiLCJrZXkiOiJhNjBlMmExMS0yOGM5LTQ3YjItYTc4OS1mZDI0YTgzMmU4OWMiLCJpYXQiOjE3Mjc4MjQzMzksImV4cCI6MzMwNTcwNDMzOSwiYXVkIjoiYWxsIn0.JBi6RWBAMTrp09PPEgJCh2aMalQPQY1O-hOaj46ANoY",
    
//     // API_URL_BASE:"http://srv-dev-sg01:8080/u_apiAutOnline.apw",

    
//     //URL_BASE: 'http://srv-hml-sg01:9494',
//     //URL_EMAIL_BASE:"https://portaldocliente.unimedvs.com.br/arqs/ajSolDoc.php",
//     //URL_BASE_PORTAL: "https://portaldocliente.unimedvs.com.br/"
    

//     API_URL_BASE: "https://webv33.unimedvs.com.br:9001/u_apiAutOnline.apw",
//     URL_BASE: 'http://srv-hml-sg01:9494/',
//     URL_EMAIL_BASE:"https://portaldocliente.unimedvs.com.br/arqs/ajSolDoc.php",
//     URL_BASE_PORTAL: "https://portaldocliente.unimedvs.com.br/",
//     API_CLIENTE_DIGITAL: "https://api-unimedvs.sensedia.com/hml/clientedigital",
//     API_URL_MOSIA: "https://api.mosiaomnichannel.com.br/clientes/ocorrencias",
//     API_TOKEN_SENSEDIA: "Basic MTQ2YzMxYzgtY2NjMC0zYTM4LTk4MWYtMzY0MmI3YjVkZWI0OmViNzgwMTQyLTM5MDAtM2Y3My05ZmE5LTNhMjM3Y2Q0ZWM1ZQ==",
//     AUT_MOSIA: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlzIjoib2NvcnJlbmNpYXMiLCJrZXkiOiJhNjBlMmExMS0yOGM5LTQ3YjItYTc4OS1mZDI0YTgzMmU4OWMiLCJpYXQiOjE3Mjc4MjQzMzksImV4cCI6MzMwNTcwNDMzOSwiYXVkIjoiYWxsIn0.JBi6RWBAMTrp09PPEgJCh2aMalQPQY1O-hOaj46ANoY", //HML
//     API_REST_PROTHEUS: "https://brokerhml.unimedvs.com.br:8045/rest/"
//     //HOMOLOGAÇÃO

// }